import React from 'react';
import { SpacingBox } from '../Boxes';
import { ProductCard } from './ProductCard';
import { ProductPresenter } from '../../presenters';

export const SmallProductCardList = ({ products, colours, tischOffensiveId, onClick }) => (
  <div className="row">
    {products.map((p) => {
      const product = ProductPresenter(p);
      const productColours = colours ? colours[product.number] : [];

      return (
        <div
          key={product.number}
          className="col-md-2 col-sm-12">
          <SpacingBox marginBottom="lg">
            <ProductCard
              onClick={onClick}
              product={product}
              tischOffensiveId={tischOffensiveId}
              colours={productColours}
            />
          </SpacingBox>
        </div>
      );
    })}
  </div>
);

SmallProductCardList.defaultProps = {
  onClick: () => {},
};
